import { CdkPortalOutlet } from '@angular/cdk/portal';
import { ChangeDetectionStrategy, Component, HostBinding, ViewEncapsulation } from '@angular/core';
import { modalAnimations } from '@df/ui/modal/modal-animations';
import { ModalContainerAbstract } from '@df/ui/modal/modal-container.abstract';

/**
 * Internal component that wraps user-provided right modal content.
 */
@Component({
    selector: 'modal-right-container',
    template: `<ng-template cdkPortalOutlet />`,
    styleUrl: './modal-container.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    animations: [modalAnimations.modalRightContainer],
    host: {
        class: 'modal-container modal-right-container',
        tabindex: '-1',
        'aria-modal': 'true',
        '[attr.id]': 'id',
        '[attr.role]': 'config.role',
        '[attr.aria-labelledby]': 'config.ariaLabel ? null : ariaLabelledBy',
        '[attr.aria-label]': 'config.ariaLabel',
        '[attr.aria-describedby]': 'config.ariaDescribedBy || null',
        '(@modalRightContainer.start)': 'onAnimationStart($event)',
        '(@modalRightContainer.done)': 'onAnimationDone($event)'
    },
    standalone: true,
    imports: [CdkPortalOutlet]
})
export class ModalRightContainerComponent extends ModalContainerAbstract {
    @HostBinding('@modalRightContainer') get getModalContainer(): any {
        return this.animationState;
    }
}
